<template>
  <div />
</template>

<script>
import { swal } from '../../share';

export default {
    name: 'EmailHelpModal',
    methods: {
        async open () {
            try {
                await swal({
                    type: 'info',
                    title: '¿No recibiste el correo?',
                    html: `
                        <div class="register-modal-content register-modal-content--email-help">
                            <p>Si el mensaje no aparece en tu bandeja de entrada en unos minutos, intentá lo siguiente:</p>
                            <ul>
                                <li>
                                    <strong>Revisá tu carpeta de Spam:</strong><br>
                                    A veces los correos automáticos son clasificados erróneamente.
                                </li>
                                <li>
                                    <strong>Verificá el espacio de tu cuenta:</strong><br>
                                    Si tu casilla (Gmail, Outlook, etc.) está <strong>llena</strong>, no podrás recibir correos nuevos hasta que liberes espacio.
                                </li>
                                <li>
                                    <strong>Confirmá tu dirección:</strong><br>
                                    Asegurate de que el correo en tu perfil sea el correcto.
                                </li>
                                <li>
                                    <strong>¿Los pasos anteriores son correctos y aún no lo recibiste?</strong><br>
                                    Contactate con el <a href="/contactos" target="_blank" rel="noopener">administrador de tu dependencia o facultad<span class="visually-hidden"> (se abre en una pestaña nueva)</span></a>.
                                </li>
                            </ul>
                        </div>
                    `,
                    confirmButtonText: 'Entendido',
                    width: 600,
                });
            } finally {
                this.$emit('closed');
            }
        },
    },
};
</script>
